import script from "./AntdIcons.vue?vue&type=script&lang=js"
export * from "./AntdIcons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__